export const initialState: LinkDataState = {};

export function linkDataReducer(
  state: LinkDataState = initialState,
  action: LinkDataAction,
): LinkDataState {
  switch (action.type) {
    case 'LINK:UPDATE': {
      const { url, linkData } = action.value;
      return { ...state, [url]: linkData };
    }

    default:
      return state;
  }
}
